/*
 * @Description:
 * @Author: tongjunyi<tongjunyi@didiglobal.com>
 * @Date: 2023-08-31 14:49:58
 * @LastEditors: tongjunyi
 * @LastEditTime: 2023-09-12 17:37:26
 */
import { Table as ATable, Empty } from '@didi-pebble/pebble-design-react';
import { i18nTranslate } from '@didi/i18n-plugin';

import { ReactComponent as EmptyIcon } from '@/assets/images/empty.svg';

const Table = ({ ...props }) => {
  return (
    <ATable
      locale={{
        emptyText: (
          <Empty
            image={<EmptyIcon width={96} height={96} />}
            description={
              <div className='mt-[14px] font-DiDiSansPro-Regular text-sm text-gray-8'>
                {i18nTranslate('Internal_Tools_2_CnTD_lDFG')}
              </div>
            }
            imageStyle={{ height: 96 }}
          />
        )
      }}
      {...props}
    />
  );
};

export default Table;
